import type {FC, ReactElement} from 'react'
import {Chip} from '@mui/material'
import {useCustomTranslation} from '@hooks/useCustomTranslation'

interface PreviewTagProps {
  sx?: object
}

const PreviewTag: FC<PreviewTagProps> = ({sx = {}}): ReactElement => {
  const [t] = useCustomTranslation('common')

  return (
    <Chip
      label={t('preview')}
      size="small"
      color="info"
      variant="outlined"
      sx={{
        fontSize: '0.6rem',
        height: '16px',
        ...sx,
      }}
    />
  )
}

export default PreviewTag
